import styled, { css } from 'styled-components'

export const Logo = styled.div`
    width: 10%;
    max-height: 50px;
    margin-left: 10px;
    z-index: 1000;
     `
